module.exports = __webpack_public_path__ + "assets/img/massage.c8867f2e.svg";